import React from 'react'

import { NavLink } from 'react-router-dom'

import {
  getAddress,
  hasTags,
  isWebpSupported,
  getQS,
} from 'helpers'

import { SiteContext } from 'context/site-context'

// import { LazyLoadImage } from 'react-lazy-load-image-component'

import './index.scss'

const Featured = ({ results = [] }) => {
  const [ site ] = React.useContext(SiteContext)

  const getFeatured = () => {
    return results.filter( business => business.featured )
  }

  const getProfileUrl = () => {
    const qs = getQS().trim().length > 0 ? `?${getQS()}` : ''
    return `${window.location.origin}/${site.path ? `${site.path}/` : ''}profile/${getFeatured()[0].id}${qs}`
  }

  return <React.Fragment>
    {getFeatured().length ? <div className="featured-container">
      <h2><span className="highlight">Recommended</span> by our Experts</h2>
      <div className="featured">
        <img src={getFeatured()[0].image || isWebpSupported() ? `//s3.amazonaws.com/assets.elocal.com/sem/assets/images/heros/citysearch-restaurant-001.webp` : `//s3.amazonaws.com/assets.elocal.com/sem/assets/images/heros/citysearch-restaurant-001.png`} />
        <div className="details-container">
          <h3><a href={getProfileUrl()}>{getFeatured()[0].name}</a></h3>
          <div className="address">{getAddress(getFeatured()[0].address)}</div>
          {hasTags(getFeatured()[0]) && <div className="tags">{getFeatured()[0].tags.filter( tag => !tag.primary ).map( tag => tag.name ).join(', ')}</div>}
          <NavLink to={getProfileUrl()} className="button-trigger mini">View details...</NavLink>
        </div>
      </div>
    </div> : null}
  </React.Fragment>
}

export default Featured
